import Buscar from './Buscar';
import MeusEstudos from './MeusEstudos';
import Visualizar from './Visualizar';

export const CursosBuscar = Buscar
export const CursosMeusEstudos = MeusEstudos;
export const CursosVisualizar = Visualizar;
